module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"noRecords":"No se encontraron noticias"},"en":{"noRecords":"No news found"},"pt":{"noRecords":"Nenhuma notícia encontrada"}}')
  delete Component.options._Ctor
}
